import { convertObjectKeysToSnakeCase } from 'chimera/all/plugins/global.functions'

export { convertObjectKeysToSnakeCase }

/**
 * Get window location values from scope (simplified from ABSmartly)
 * Only includes analytically valuable properties:
 * - pathname: Essential for identifying page/step
 * - search: Important for UTM/campaign attribution
 * - href: Convenient for debugging
 * @param {object} scope - Event scope
 * @returns {object} Window location properties
 */
export function getWindowLocationValues(scope) {
  return {
    pathname: scope?.pathname,
    search: scope?.search,
    href: scope?.href,
  }
}
